
  <div class="card" >
    <div class="card-body">
      <app-onboarding-uploaddocs *ngIf="profile" [profile]="profile">
      </app-onboarding-uploaddocs>
      <app-uploads-certification *ngIf="profile" [profile]="profile">
      </app-uploads-certification>
    </div>
  </div>
